<script>
    import Field from "./Field.svelte";
    export let field;
    export let value = null;
    export let error = "";
    export let valid = true;
    export let locale = "en";

    if (!value && field.localizable) {
        value = { [locale]: null };
    } else if (typeof value !== "object" && field.localizable) {
        value = { [locale]: value };
    }
</script>

{#if field.localizable}
    <Field bind:value={value[locale]} bind:valid bind:error bind:field />
{:else}
    <Field bind:value bind:valid bind:error bind:field />
{/if}
